import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Card, CardContent } from '@/components/ui/card';
import { Quote } from 'lucide-react';
import { getImageAssetPath } from '@/lib/imageHelper';

const FoundersSection = () => {
  const ddiImagePath = getImageAssetPath('ddi.jpeg');
  const sbrImagePath = getImageAssetPath('sbr.jpeg');

  return (
    <section className="py-16 md:py-24 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Was unsere Gründer über <span className="text-blue-600">E-Commerce</span> sagen
          </h2>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto">
            Dennis und Simon haben bereits viele E-Commerce-Projekte realisiert und teilen ihre Leidenschaft für digitale Geschäftsmodelle.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-8">
          {/* Dennis Dittrich Zitat */}
          <Card className="border-none shadow-lg bg-white">
            <CardContent className="p-8">
              <div className="flex items-start gap-4 mb-6">
                <Quote className="w-8 h-8 text-blue-600 flex-shrink-0 mt-1" />
                <div>
                  <p className="text-lg text-gray-700 italic leading-relaxed mb-6">
                    "Ich liebe es, mit Kunden digitale Geschäftsmodelle zu entwickeln. Sei es ein einfacher Shop, der verschiedene Sales-Channels anschließt, oder Portale für Lieferanten zu entwickeln, um damit auch wirkliche USPs zu erschaffen."
                  </p>
                </div>
              </div>
              
              <div className="flex items-center gap-4">
                <Avatar className="w-16 h-16 border-2 border-orange-200">
                  <AvatarImage src={ddiImagePath} alt="Dennis Dittrich" />
                  <AvatarFallback className="bg-orange-100 text-orange-700 text-lg font-bold">DD</AvatarFallback>
                </Avatar>
                <div>
                  <h3 className="text-xl font-bold">Dennis Dittrich</h3>
                  <p className="text-gray-600">Software-Entwicklung Experte</p>
                </div>
              </div>
            </CardContent>
          </Card>
          
          {/* Simon Brüggemann Zitat */}
          <Card className="border-none shadow-lg bg-white">
            <CardContent className="p-8">
              <div className="flex items-start gap-4 mb-6">
                <Quote className="w-8 h-8 text-green-600 flex-shrink-0 mt-1" />
                <div>
                  <p className="text-lg text-gray-700 italic leading-relaxed mb-6">
                    "E-Commerce ist mehr als nur ein Online-Shop. Die Herausforderung liegt darin, alle Systeme nahtlos zu vernetzen - vom ERP über die Marktplätze bis hin zum Marketing. Wenn alles perfekt zusammenspielt, entstehen echte Wettbewerbsvorteile."
                  </p>
                </div>
              </div>
              
              <div className="flex items-center gap-4">
                <Avatar className="w-16 h-16 border-2 border-blue-200">
                  <AvatarImage src={sbrImagePath} alt="Simon Brüggemann" />
                  <AvatarFallback className="bg-blue-100 text-blue-700 text-lg font-bold">SB</AvatarFallback>
                </Avatar>
                <div>
                  <h3 className="text-xl font-bold">Simon Brüggemann</h3>
                  <p className="text-gray-600">IT-System & Transformations Spezialist</p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Gemeinsame Einschätzung */}
        <div className="bg-white rounded-xl shadow-lg p-8 max-w-4xl mx-auto mt-12">
          <div className="text-center">
            <h3 className="text-2xl font-bold mb-4">Unser E-Commerce Ansatz</h3>
            <p className="text-lg text-gray-700 leading-relaxed">
              "Wir entwickeln nicht nur Shops, sondern komplette digitale Ökosysteme. Von der ersten Idee über die technische Umsetzung bis hin zur Marketing-Strategie - wir denken E-Commerce ganzheitlich und schaffen echte Wettbewerbsvorteile für unsere Kunden."
            </p>
            <div className="flex justify-center items-center gap-8 mt-6">
              <div className="text-center">
                <p className="font-semibold">Dennis Dittrich</p>
                <p className="text-sm text-gray-600">Gründer & Entwickler</p>
              </div>
              <div className="w-px h-12 bg-gray-300"></div>
              <div className="text-center">
                <p className="font-semibold">Simon Brüggemann</p>
                <p className="text-sm text-gray-600">Gründer & IT-Spezialist</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FoundersSection; 